import { size } from "lodash";
import React from "react";
import { Table } from "semantic-ui-react";

const AntiTable = ({ groupedAntibiotics, comentarioAnti}) => {
  return (
    //<Table celled striped>
    <Table attached="bottom" striped size="small" compact='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="4" textAlign="center">
            PRUEBA DE SENSIBILIDAD A LOS DIFERENTES ANTIMICROBIANOS
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {groupedAntibiotics.map((group, idx) => {
          const { desc_germen, antibioticos,comentario } = group;

          if (!desc_germen || desc_germen === "A/B" || desc_germen === "Positivo") return null;

          return (
            <React.Fragment key={idx}>
              <Table.Row>
                <Table.Cell>
                  
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell style={{
                  fontWeight: "bold",
                  background: "#F0F0F0",
                  borderTop:"3px solid #00ACC9",
                  }}>
                    {desc_germen}
                </Table.Cell>
                
                <Table.Cell colSpan="2" style={{
                  fontWeight: "bold",
                  background: "#F0F0F0",
                  borderTop:"3px solid #00ACC9"
                  }}>
                    { comentario && (
                      <div
                    style={{color : "gray"}}
                    dangerouslySetInnerHTML={{
                      __html: "Comentario: " + comentario.HTML
                    }}>
                  </div>
                  )} 
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell style={{
                  fontWeight: "bold",
                  background: "#F0F0F0",
                  }}>
                   Antibioticos
                </Table.Cell>
                <Table.Cell style={{
                  fontWeight: "bold",
                  background: "#F0F0F0",
                  }}>
                    Sensibilidad
                </Table.Cell>
                <Table.Cell style={{
                  fontWeight: "bold",
                  background: "#F0F0F0",
                  }}>
                    Valor
                </Table.Cell>
              </Table.Row>
              {antibioticos.length > 0 ? antibioticos.map((anti,i) => (
                <React.Fragment key={`${idx}-${i}`}>
                  <Table.Row>
                    <Table.Cell
                    style={{
                      paddingLeft:"2rem",
                      fontWeight:"bold",             
                    }}
                    >
                      {anti.nombre}
                    </Table.Cell>
                    <Table.Cell>
                      {
                        anti.sensible
                        ? "Sensible"
                        : anti.resistente
                        ? <b>Resistente</b>
                        : anti.sensible_medio
                        ? "Intermedio"
                        : anti.es_positiva
                        ? "Positivo"
                        : "Negativo"
                      }
                    </Table.Cell>
                    <Table.Cell>
                      {anti.valor}
                    </Table.Cell>
                </Table.Row>
                </React.Fragment>
              )):(
                <Table.Row>
                  <Table.Cell colSpan="4">
                    Sin antibioticos asociados
                  </Table.Cell>
                </Table.Row>
              )}
            </React.Fragment>
          )
        })}
      </Table.Body>
    </Table>
  );
};

export default AntiTable;
